module.exports = __webpack_public_path__ + "static/media/image_17.85e71403.png";